import { AD_CONFIG } from './adConfig';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export class AdManager {
  private static loaded = false;

  /** AdSense script'ini asenkron yükle (sadece bir kez) */
  static async init(): Promise<void> {
    if (this.loaded) return;
    if (import.meta.env.DEV) {
      console.log('[AdManager] DEV ortamında AdSense pas geçildi.');
      this.loaded = true;
      return;
    }

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CONFIG.clientId}`;
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onload = () => {
        this.loaded = true;
        resolve();
      };
      script.onerror = () => {
        console.warn('[AdManager] AdSense script yüklenemedi (AdBlocker olabilir).');
        resolve(); // Reklam engelli ise uygulamayı aksatmamak için sessizce tamamla
      };
      document.head.appendChild(script);
    });
  }

  /** Bir ins elementini adsbygoogle array'ine push et */
  static pushAd(): void {
    if (import.meta.env.DEV) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn('[AdManager] pushAd hatası:', e);
    }
  }
}
